import styled from 'styled-components';

export const CategoryNavigatorSection = styled.div`
  h2 {
    font-size: clamp(16px, 2vw, 20px);
    padding: 0px 20px 0px;
    color: #414141;
    position: relative;
    font-weight: 600;
    text-transform: uppercase;
    margin: 10px 0;
    width: max-content;
  }
  @media (min-width: 768px) {
    h2 {
      flex-basis: 100%;
      padding: 0;
    }
    width: 80%;
    margin: auto;
  }
`;
export const NavigatorTile = styled.div`
  display: flex;
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #ddd;
  p {
    font-size: clamp(14px, 2vw, 16px);
    color: #535353;
  }
  font-weight: 500;
  img {
    width: 14px;
    rotate: -90deg;
    height: 14px;
  }
  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 600ms linear;
    background-color: hsl(0deg, 0%, 0%, 18%);
  }

  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  @media (min-width: 768px) {
    border: none;
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    padding: 20px;
  }
`;

export const RelatedCategoryCover = styled.div`
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin: auto;
    padding: 0;
    gap: 25px;
  }
`;
